import { RSNT_NAMESPACE_ID } from "src/constants";
import { SMARTMATCH_TYPE_RATE_APPROVER } from "src/services/constants";
import { USER_ONBOARD_ADMIN, USER_ONBOARD_CREDIT_MANAGER, USER_ONBOARD_DIGITAL_RM, USER_ONBOARD_LOAN_OFFICER, USER_ONBOARD_CDP_OFFICER, USER_ONBOARD_CLOSED_LOAN_EDIT_MANAGER, AUDITOR } from "src/services/constants/accounts";
import SiteSettings from 'src/siteSetting';

const ADMIN_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 0
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 1
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 4
    },
    {
        title: "Denial Under Review",
        key: "denial_under_review",
        order_id: 3
    },
    {
        title: "Approved Not Accepted",
        key: "approved_not_accepted",
        order_id: 5
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 6
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 7
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 8
    },
    {
        title: "Credit Management",
        key: "credit_management",
        order_id: 2
    },
    {
        title: "Central Group",
        key: "central_group",
        order_id: 9
    },
    {
        title: "CDP Queue",
        key: "cdp_queue",
        order_id: 10
    },
]


export const AUDITOR_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 0
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 1
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 4
    },
    {
        title: "Denial Under Review",
        key: "denial_under_review",
        order_id: 3
    },
    {
        title: "Approved Not Accepted",
        key: "approved_not_accepted",
        order_id: 5
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 6
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 7
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 8
    },
    {
        title: "Credit Management",
        key: "credit_management",
        order_id: 2
    },
    {
        title: "Central Group",
        key: "central_group",
        order_id: 9
    },
    {
        title: "CDP Queue",
        key: "cdp_queue",
        order_id: 10
    },
]

export const CREDIT_MANAGER_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 0
    },
     {
        title: "Credit Management",
        key: "credit_management",
        order_id: 1
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 2
    },
   
    {
        title: "Denial Under Review",
        key: "denial_under_review",
        order_id: 3
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 4
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 5
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 6
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 7
    },
]


export const CDP_MANAGER_TABS = [
    {
        title: "CDP Queue",
        key: "cdp_queue",
        order_id: 0
    },
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 1
    },
    {
        title: "Central Group",
        key: "central_group",
        order_id: 2
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 3
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 4
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 5
    },
]






export const DIGITAL_RM_TABS = [
    {
        title: "Central Group",
        key: "central_group",
        order_id: 0
    },
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 1
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 2
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 3
    },

    {
        title: "Approved Not Accepted",
        key: "approved_not_accepted",
        order_id: 4
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 5
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 6
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 7
    },
    {
        title: "CDP Queue",
        key: "cdp_queue",
        order_id: 8
    }
]

export const RELATIONSHIP_MANAGER_TABS = [
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 1
    },
    {
        title: "My Completed",
        key: "my_completed",
        order_id: 2
    },
    {
        title: "My Declined",
        key: "my_declined",
        order_id: 3
    }
]

export const LOAN_EDIT_MANAGER_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 1
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 2
    },


    {
        title: "Completed",
        key: "completed",
        order_id: 4
    }
]

export const rsntPipelineConfig = [
    {
        namespaceId: RSNT_NAMESPACE_ID,
        role: USER_ONBOARD_LOAN_OFFICER,
        tabs: RELATIONSHIP_MANAGER_TABS
    },
    {
        namespaceId: RSNT_NAMESPACE_ID,
        role: USER_ONBOARD_CLOSED_LOAN_EDIT_MANAGER,
        tabs: LOAN_EDIT_MANAGER_TABS
    },
    {
        namespaceId: RSNT_NAMESPACE_ID,
        role: USER_ONBOARD_ADMIN,
        tabs: ADMIN_TABS
    },
    {
        namespaceId: RSNT_NAMESPACE_ID,
        role: 'admin_digital_relationship_manager',
        tabs: ADMIN_TABS
    },
    {
        namespaceId: RSNT_NAMESPACE_ID,
        role: USER_ONBOARD_DIGITAL_RM,
        tabs: DIGITAL_RM_TABS
    },
    {
        namespaceId: RSNT_NAMESPACE_ID,
        role: USER_ONBOARD_CDP_OFFICER,
        tabs: CDP_MANAGER_TABS
    },
    {
        namespaceId: RSNT_NAMESPACE_ID,
        role: USER_ONBOARD_CREDIT_MANAGER,
        tabs: CREDIT_MANAGER_TABS
    },
    {
        namespaceId: RSNT_NAMESPACE_ID,
        role: SMARTMATCH_TYPE_RATE_APPROVER,
        tabs: RELATIONSHIP_MANAGER_TABS
    },
    {
        namespaceId: RSNT_NAMESPACE_ID,
        role: AUDITOR,
        tabs: AUDITOR_TABS
    }
];

